export default __webpack_public_path__ + "static/media/I.dd45e387.png";